import React, { useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import DemandesRdvList from '../../components/DemandesRdvList';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DemandesRdvPage = () => {
  const { token } = useAuth();
  const getAuthHeaders = useCallback(
    () => ({ Authorization: `Bearer ${token}` }),
    [token],
  );

  return (
    <div className="p-4 sm:p-6">
      <DemandesRdvList
        apiBase={`${API}/rdv-demandes`}
        getAuthHeaders={getAuthHeaders}
        scopeLabel="Toutes les demandes reçues via le widget public (tous garages)"
        showGarageColumn
      />
    </div>
  );
};

export default DemandesRdvPage;
